import HackathonSearch from '@/components/HackathonSearch.vue'
import store from '@/stores'
import ClickOutside from '@/directives/click_outside'

import { mountApp } from '@/apps/mount_app';

export default () => {
  mountApp({
    domId: 'hackathon-search',
    component: HackathonSearch,
    raiseOnFailure: true,
    beforeMount: (app) => {
      app.use(store);
      app.directive('outside-click', ClickOutside);
    }
  })
}
